import { rem } from "polished";
import styled from "styled-components";

export const IconLinkWrapper = styled.a`
  padding: ${rem(4)};
  margin-top: ${rem(12)};

  * {
    cursor: pointer;
  }
`;

export const Card = styled.div`
  display: grid;
  gap: ${rem(12)};

  .text-primitive {
    text-align: center;
  }
`;
